import React from "react";
import * as Icon from "react-feather";
import WComponent from "../../../../../../../common/WComponent";

class ContextChangeProposal extends WComponent {
	state = { applied: false };

	render() {
		let { change, onApprove } = this.props;
		let { applied } = this.state;

		if (applied) {
			return (
				<div className="afs-review__exec-proposal afs-review__exec-proposal--done">
					<Icon.CheckCircle size={14} color="#2e7d32" />
					<span className="afs-review__exec-proposal-confirmed">{change.label}</span>
				</div>
			);
		}

		return (
			<div className="afs-review__exec-proposal">
				<div className="afs-review__exec-proposal-entry">
					<div className="afs-review__exec-proposal-line">
						<span className="afs-review__exec-proposal-side">From</span>
						<span>{change.currentValue}</span>
					</div>
					<div className="afs-review__exec-proposal-line">
						<span className="afs-review__exec-proposal-side">To</span>
						<span className="afs-review__exec-proposal-value">{change.newValue}</span>
					</div>
				</div>
				<button className="afs-review__exec-proposal-approve" onClick={() => {
					if (onApprove) onApprove(change);
					this.update({ applied: true });
				}}>
					<Icon.Check size={14} /> {change.label || "Apply Change"}
				</button>
			</div>
		);
	}
}

export default ContextChangeProposal;
